import React from "react";

import { CheckIcon } from "../../constants/icons";

interface ItemProps {
  title: string;
  onClick?: () => void;
  showTickIcon?: boolean;
}

const LanguageItem: React.FC<ItemProps> = ({
  title,
  onClick,
  showTickIcon = false,
}) => {
  return (
    <div onClick={onClick}>
      <div className="language-item">
        <p className="title">{title}</p>
        {showTickIcon ? (
          <CheckIcon
            color="white"
            className="tick-icon"
            size={20}
            fontWeight={100}
          />
        ) : null}
      </div>
    </div>
  );
};

export default LanguageItem;
